/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DistributionListItem } from '../models/distribution-list-item';
@Injectable({
  providedIn: 'root',
})
class DistributionListItemService extends __BaseService {
  static readonly DistributionListItemCreateOrUpdatePath = '/api/DistributionListItem/CreateOrUpdate';
  static readonly DistributionListItemGetDistributionListItemsPath = '/api/DistributionListItem/GetDistributionListItems';
  static readonly DistributionListItemDeletePath = '/api/DistributionListItem/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param item undefined
   */
  DistributionListItemCreateOrUpdateResponse(item: DistributionListItem): __Observable<__StrictHttpResponse<DistributionListItem>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = item;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/DistributionListItem/CreateOrUpdate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DistributionListItem>;
      })
    );
  }
  /**
   * @param item undefined
   */
  DistributionListItemCreateOrUpdate(item: DistributionListItem): __Observable<DistributionListItem> {
    return this.DistributionListItemCreateOrUpdateResponse(item).pipe(
      __map(_r => _r.body as DistributionListItem)
    );
  }

  /**
   * @param distributionListId undefined
   */
  DistributionListItemGetDistributionListItemsResponse(distributionListId?: number): __Observable<__StrictHttpResponse<Array<DistributionListItem>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (distributionListId != null) __params = __params.set('distributionListId', distributionListId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/DistributionListItem/GetDistributionListItems`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DistributionListItem>>;
      })
    );
  }
  /**
   * @param distributionListId undefined
   */
  DistributionListItemGetDistributionListItems(distributionListId?: number): __Observable<Array<DistributionListItem>> {
    return this.DistributionListItemGetDistributionListItemsResponse(distributionListId).pipe(
      __map(_r => _r.body as Array<DistributionListItem>)
    );
  }

  /**
   * @param id undefined
   */
  DistributionListItemDeleteResponse(id: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/DistributionListItem/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DistributionListItemDelete(id: number): __Observable<Blob> {
    return this.DistributionListItemDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module DistributionListItemService {
}

export { DistributionListItemService }
